module.exports = __webpack_public_path__ + "img/hint-2fa.b6a7a62a.svg";